import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const serviceLinks = [
    { path: '/category/short-video', label: t('categoryShortVideo') },
    { path: '/category/brand-marketing', label: t('categoryBrandMarketing') },
    { path: '/category/ad-planning', label: t('categoryAdPlanning') },
    { path: '/category/social-media', label: t('categorySocialMedia') },
    { path: '/category/content-creative', label: t('categoryContentCreative') },
    { path: '/category/full-service', label: t('categoryFullService') },
  ];

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h3 className="text-lg font-heading font-bold text-white mb-4">{t('siteName')}</h3>
              <p className="text-sm text-foreground-400 leading-relaxed">{t('siteSlogan')}</p>
              <div className="flex items-center gap-4 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="抖音">
                  <i className="ri-tiktok-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-200" aria-label="小红书">
                  <i className="ri-booklet-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">{t('navCategory')}</h4>
              <ul className="space-y-2.5">
                {serviceLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">{t('navAbout')}</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">{t('aboutIntro')}</Link>
                </li>
                <li>
                  <Link to="/about#honor" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">{t('aboutHonor')}</Link>
                </li>
                <li>
                  <Link to="/about#contact" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">{t('aboutContact')}</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">{t('footerContact')}</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                  <span>{t('footerAddress')}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line text-foreground-500"></i>
                  <span>{t('footerPhone')}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-foreground-500"></i>
                  <span>{t('footerEmail')}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">{t('footerRights')}</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">{t('footerPrivacy')}</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">{t('footerTerms')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}